import React, { useState } from "react";
import { Col, Modal, Row, Form } from "react-bootstrap";
import Image from "../assets/hireus-modal.svg";
function HireUsModal({ outlined }) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <button
        className={outlined ? "btn btn-custom-outlined" : "btn btn-custom"}
        onClick={handleShow}
        style={outlined ? { color: "black" } : {}}
      >
        {outlined ? "Hire Developer" : "Hire Us"}
      </button>

      <Modal show={show} onHide={handleClose} size="lg" centered>
        <Modal.Header closeButton className="modalHeader">
          <Modal.Title>Hire Us</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col xs={12} md={6}>
              <img src={Image} alt="..." className="topImage img-fluid" />
            </Col>
            <Col xs={12} md={6}>
              <Form>
                <Form.Group lg="12">
                  <Form.Control type="name" placeholder="Name" />
                </Form.Group>
                <Form.Group lg="12">
                  <Form.Control type="email" placeholder="Email" />
                </Form.Group>
                <Form.Group lg="12">
                  <Form.Control type="phone" placeholder="Phone Number" />
                </Form.Group>

                <button className="btn btn-custom">Submit</button>
                <Form.Text className="text-muted">
                  Reach us with your details, & we'll get back to you ASAP!
                </Form.Text>
              </Form>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default HireUsModal;
